import { createGlobalStyle } from "styled-components";

const TransitionCSS = createGlobalStyle`
  .trx-all {
    transition: width 0.1s ease-in, height 0.1s ease-in, border-color 0.1s ease-in,
      box-shadow 0.1s ease-in;
  }
  
  .trx-width {
    transition: width 0.1s ease-in;
  }
  
  .trx-height {
    transition: height 0.1s ease-in;
  }
`;

export default TransitionCSS;
